import {getUrlParams} from '../Utility/utils';
/**************************************************
 * init_post_filter()
 * filtering front end function for filtering beers posts
 * retrieves selected values from filter form and passes them to PHP function
 * ajax_filter_get_posts()
 */

function get_filter_items(){
    var items = {
        'classes' : {
            'visible' : 'is-inview',
            'hidden' : 'hidden',
        },
       'containers' : {
            'default' : $('#post_results_original'),
            'results' : $('#post_results_new'),
            'alm'     : $('#post_results_original + .alm-load-more'),
            'error'   : {
                'container' : $('#post_results_error'),
                'textWrap' :  $('#no-result-val'),
            }
       },
      'resetFilters'  : $('.filter_reset_post'),
      'search' : {
          'field'     : $('#cat_name'),
          'trigger'   : $('.trigger_filter__search'),
          'class'     : 'trigger_filter__search',
      },
      'filter' : {
          'elems'     : $('.trigger_filter'),
      },
      'select' : $('.filter__select__trigger'),
  };

  return items;
}

function init_post_filter() {

 var preloader = document.createElement('div');
 preloader.id = 'preloader';
 preloader.classList = 'mt-5 mb-5';
 preloader.html = '<h3>LOADING...</h3>';

 var items = get_filter_items();


  items.select.click(function(e){
     e.preventDefault();
  });

  items.filter.elems.each(function() {
      // on filter click or search submit
      $(this).click(function(event) {

      let is_search = false;

        // Prevent default action - opening tag page
        if (event.preventDefault) {
          event.preventDefault();
        }
        else {
          event.returnValue = false;
        }
        // initial scroll to top of results container
        $('html, body').animate({
            scrollTop: $('#post_results').offset().top - 300,
        }, 100, function() {
          // Animation complete.
        });

        // set TRUE to search Or filter link
        this.classList.contains(items.search.class) ? is_search = true : is_search = false;

        // define default filter options
        var filter_opts = {
            'postType' : null,
            'postCat' : null,
            'name' : items.search.field.val(),
            'type' : null,
            'postTag' : null,
            'order' : null,
            'location' : null,
            'tax'      : null,
            'shortcode' : null,
        };

        // Define post type
        if($('body').hasClass('category-news')){
          filter_opts.postType = 'post';
          filter_opts.postCat = 'news';
        }
        else if($('body').hasClass('category-blog')){
          filter_opts.postType = 'post';
          filter_opts.postCat = 'blog';
        }
        else if($('body').hasClass('post-type-archive-events')){
          filter_opts.postType = 'events';
        }
        else {
          filter_opts.postType = 'brooklyn-beers';
        }

        // For event filtering, we'll need the current date
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        today = yyyy + '' + mm + '' + dd;

        // SUBMISSION VALIDATION

        // first check: If not search & filter not already active
        if(!is_search && !$(this).hasClass('active')) {
            // get the data that will be used to filter posts by
            if(filter_opts.postType == 'brooklyn-beers'){
                filter_opts.postCat = $(this).attr('data-val');
                filter_opts.tax = 'beer-primary-cat';
            }
            if($(this).hasClass('filter_tax')){
                if(filter_opts.postType == 'post'){
                    let tag = $(this).attr('data-val');
                    filter_opts.postTag = tag;
                    filter_opts.shortcode = '[ajax_load_more id="akkposts" repeater="template_1" container_type="div" css_classes="row" transition_container_classes="grid__archive" post_type="post" category="'+filter_opts.postCat+'" posts_per_page="12" post_format="standard" order="ASC" orderby="menu_order" preloaded="true" preloaded_amount="12" pause="true" scroll="false" images_loaded="true" scroll_container=".alm-load-more" button_label="LOAD MORE" button_loading_label="LOADING POSTS..."]';
                }
                else if(filter_opts.postType == 'events'){
                    filter_opts.postCat = $(this).attr('data-val');

                    filter_opts.shortcode = '[ajax_load_more id="akkposts" repeater="template_2" meta_key="event_end_date" meta_value="'+today+'" meta_compare=">=" meta_type="NUMERIC" orderby="meta_value_num" order="ASC" category="'+filter_opts.postCat+'" container_type="div" css_classes="row" transition_container_classes="row archive-grid" post_type="events" posts_per_page="12" post_format="standard" offset="7" pause="true" scroll="false" images_loaded="true" scroll_container=".alm-load-more" button_label="SEE ALL UPCOMING EVENTS" button_loading_label="LOADING EVENTS..."]';
                }
            }
            if($(this).hasClass('filter_order')){
                filter_opts.order = $(this).attr('data-val');
            }
            if($(this).hasClass('filter_event_location')){
                filter_opts.location = $(this).attr('data-location');
            }
            if($(this).hasClass('filter_event_date')){
                filter_opts.date = $(this).attr('data-date');
            }

            items.filter.elems.removeClass('active');
            $(this).addClass('active');
        } else if(is_search && filter_opts.name !== '') {
            // second check: is search field and search field isn't blank
            filter_opts.type = 'search';
        } else {
            // failed filter validation, either filter is active, or search is empty
            if(is_search) {
                document.getElementById('cat_name').focus(); // for search we focus into field
            }
            return false;// exit click event
        }

        // PASSED VALIDATION
        items.containers.results.html(preloader);
        $('#preloader').css('opacity', 1);

        var data = {
          action: 'filter_beers', // function to execute
          afp_nonce: afp_vars.afp_nonce, // wp_nonce
          filterOptions: filter_opts // selected tag
        };

        $.post(afp_vars.afp_ajax_url, data, function(response) {
            if (response) {
                if(!is_search) {
                    items.containers.error.container.addClass(items.classes.hidden);
                    items.containers.default.addClass(items.classes.hidden);
                    items.containers.results.html(response);
                    items.containers.results.removeClass(items.classes.hidden);

                    $('.trigger_filter__beer').blur();
                    if($('#post_results').length){
                        $('#post_results .card').each(function() {
                            $(this).addClass(items.classes.visible);
                        });
                    }
                } else {
                    if(response == '0') {
                        items.containers.error.textWrap.html('"' + filter_opts.name + '"');
                        items.containers.error.container.removeClass(items.classes.hidden);
                        items.containers.results.addClass(items.classes.hidden);
                        items.containers.default.addClass(items.classes.hidden);
                    } else {
                        items.containers.error.container.addClass(items.classes.hidden);
                        items.containers.default.addClass(items.classes.hidden);
                        items.containers.results.html(response);
                        items.containers.results.removeClass(items.classes.hidden);
                        if($('#post_results .card').length){
                            items.search.field.blur();
                            items.search.trigger.blur();
                            $('#post_results .card').each(function() {
                                $(this).addClass(items.classes.visible);
                            });
                        }
                    }
                }
            }
        }).done(function() {
        }).fail(function() {
          console.log( "error fetching results" );
        }).always(function() {
          // console.log( "finished" );
        });

    });
  });
}

function show_hide_filter(){
    const scroll_pos = $(window).scrollTop();
    const filter = $('#filter-wrapper');

    if(scroll_pos > 250){
        filter.addClass('active');
    } else {
        filter.removeClass('active');
    }
}

$(document).ready(() => {
    if($('.trigger_filter').length) {
        init_post_filter();
    }

    if($('#filter-wrapper').length) {
        show_hide_filter();

        $(window).scroll(debouncer(function(){
            show_hide_filter();
        }, 20));
    }

    // Check if a location or type are already set upon landing on the page
    const urlParams = getUrlParams();
    if(urlParams.loc || urlParams.type){
      $('body').addClass('filtered');
      almFilterComplete(false);
    }
});

// News / Blog / Events Filtering
// On complete of click filter / search filter
function almFilterComplete(includeScroll = true){
    // Hide the original posts
    $('#post_results_original').hide();

    const errorContainer = $('#post_results_error');
    let bodyScroll = false;

    window.almDone = function(){
        const almPostCount = $('.ajax-load-more-wrap').attr('data-total-posts');
        const almButton = $('.alm-btn-wrap button');
        if(almPostCount > 0){
            errorContainer.addClass('hidden');
            almButton.css({'opacity': '1', 'visibility': 'visible'});
            bodyScroll = includeScroll ? $('#post_results').offset().top - 200 : false;
        } else {
            errorContainer.removeClass('hidden');
            almButton.css({'opacity': '0', 'visibility': 'hidden'});
            bodyScroll = includeScroll ? $('#post_results').offset().top : false;
        }

        // initial scroll to top of results container
        if(bodyScroll){
          $('html, body').stop().animate({
            scrollTop: bodyScroll,
          }, 100, function() {
            // Animation complete.
          });
        }
    };

    window.almOnChange = function(alm){
    	errorContainer.addClass('hidden');
    };
}


// Filter Click Event
function filterClick(e){
    e.preventDefault();
    this.blur();

    // Alter the URL with params, if present
    const paramKey = $(this).attr('data-url-param');
    const paramVal = $(this).attr('data-url-param-val');
    const url = window.location;
    if(paramKey && paramVal){
      const newURL = url.origin + url.pathname + '?' + paramKey + '=' + paramVal;
      history.replaceState({}, '', newURL);
    }
    else {
      history.replaceState({}, '', url);
    }

    if(this.classList.contains('disabled') || this.classList.contains('active')){
        return;
    }

    $('#filter-wrapper .filter__category .active').removeClass('active');
    if(!$(this).hasClass('alm_reset_trigger')){
        this.classList.add('active');
    }

    if(!this.classList.contains('alm-load-more-btn')){
        $('.grid__archive').addClass('filtered');
    }

	var transition = 'fade';
	var speed = 250;
	var data  = this.dataset;
	// Call Ajax Load More `filter` method
	ajaxloadmore.filter(transition, speed, data);

    almFilterComplete();
}

// Get all buttons
var buttons = document.querySelectorAll('.alm-filter-trigger');
if(buttons){
   // Loop each button and add click event
	[].forEach.call(buttons, function(button) {
        button.addEventListener('click', filterClick);
	});
}


// News / Blog / Event Search
// Required to do as a separate function than above due to ajax load more
$('.alm_search_trigger').click(function(event){

    // Prevent default action - opening tag page
    if (event.preventDefault) {
      event.preventDefault();
    }
    else {
      event.returnValue = false;
    }

    let searchValue = $('#filter-wrapper input[type="text"]').val();

    if(searchValue == ''){
        return;
    }

    $(this)
        .attr('data-posts-per-page', '12')
        .attr('data-offset', '0')
        .attr('data-format', 'standard')
        .attr('data-pause', 'false')
        .attr('data-scroll', 'false')
        .attr('data-order', 'DESC')
        .attr('data-search', searchValue);

    // Define post type for specific filtering data
    let postType;
    if($('body').hasClass('category-news')){
        postType = 'post';
        $(this).attr('data-category', 'news');
    }
    else if($('body').hasClass('category-blog')){
        postType = 'post';
        $(this).attr('data-category', 'blog');
    }
    else if($('body').hasClass('post-type-archive-events')){
        $(this)
            .attr('data-post-type', 'events')
            .attr('data-meta-key', '')
            .attr('data-meta-type', '')
            .attr('data-meta-value', '')
            .attr('data-orderby', '')
            .attr('data-taxonomy-operator', '')
            .attr('data-taxonomy-terms', '')
            .attr('data-meta-compare', '');
    }

    if(postType == 'post'){
        $(this)
            .attr('data-post-type', 'post')
            .attr('data-tag', '');
    }

	var transition = 'fade';
	var speed = 250;
	var data  = this.dataset;
	// Call Ajax Load More `filter` method
	ajaxloadmore.filter(transition, speed, data);

    almFilterComplete();
});

// For the events page, since sometimes there won't be upcoming events,
// we'll change the body class on filtering to display different messaging.

$('body').on('click', '.alm-filter-trigger', function(){
    if(!$(this).hasClass('remove_filters_trigger')){
        $('body').addClass('filtered');
    }
});

$('body').on('click', '.remove_filters_trigger, .filter_event_date[data-meta-compare=">="]', function(e){
    $('body.filtered').removeClass('filtered');
});

/* ----------------------
Mobile Filter UI
---------------------- */
// used for window resize functions to reduce function calls
function debouncer( func , timeout ) {
    var timeoutID , timeout = timeout || 20;
    return function () {
        var scope = this , args = arguments;
        clearTimeout( timeoutID );
        timeoutID = setTimeout( function () {
            func.apply( scope , Array.prototype.slice.call( args ) );
        } , timeout );
    };
}

// function to close the mobile filters list
function closePostFilters() {
    $('#filter-wrapper').removeClass('triggered');
    $('.filter__select').removeClass('option-active');
}

// function to remove mobile classes if window goes larger than 991px
function responsiveFilterClasses() {
    const windowWidth = $(window).innerWidth();
    const filterBar = $('#filter-wrapper');
    if(windowWidth > 990 && filterBar.length){
        closePostFilters();
    }
}

$( window ).resize( debouncer( function ( e ) {
   responsiveFilterClasses();
} ) );

// Show filter bar
$('.post-filter-trigger').on('click touch', function(e){
    e.preventDefault();
    $(this).blur();
    $('#filter-wrapper').toggleClass('triggered');
});

// Hide filter bar on filter click
$('.alm-filter-trigger, .alm_search_trigger, .trigger_filter').click(function(e){
    $('#filter-wrapper').removeClass('triggered');
    $('.filter__select.option-active').removeClass('option-active');
});

// Expand / Close sub-menu filter lists
$('.filter__select__trigger').click(function(e){
    e.preventDefault();
    $(this).blur();
    const parent = $(this).closest('li');
    parent.toggleClass('option-active');
    $('.filter__select.option-active').not(parent).removeClass('option-active');
});

// Close filter menu
$('.filter-menu-close').click(function(e){
    e.preventDefault();
    $(this).blur();
    closePostFilters();
})
